import SCPData from "./SCPData";
import PlayerDataPage from "../UserComponents/PlayerDataPage";

export default class SCPDataPlayerPage extends PlayerDataPage {
  playerDataUrl(steamid: string): string {
    return "https://rhd-api.tenmahw.com/scp/player/info?steamid=" + steamid;
  }

  dataComponent(data: any): JSX.Element {
    return <SCPData player={data}/>;
  }
}
